var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.googleAnalyticsManager},[(_vm.gaUrlId)?_c('ThirdPartyScript',{attrs:{"value":_vm.gaScript}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }